import { Component } from '@angular/core';

import {NavController, NavParams} from 'ionic-angular';

import { AboutPage } from '../../about/about';
import { TestPage } from '../../test/test';
import { MapPage } from '../../map/map';
import { SchedulePage } from '../../schedule/schedule';
import { SpeakerListPage } from '../../speaker-list/speaker-list';
import {UserData} from "../../../providers/user-data";
import {CivilityPage} from "../civility/civility";
import {AddressPage} from "../address/address";
import {IdentityPage} from "../identity/identity";
import {DocumentsPage} from "../documents/documents";


@Component({
  templateUrl: 'tabs.html'
})
export class AccountTabsPage {
  // set the root pages for each tab
  tab1Root: any = CivilityPage;
  tab2Root: any = AddressPage;
  tab3Root: any = IdentityPage;
  tab4Root: any = DocumentsPage;

  mySelectedIndex: number;

  constructor(
      navParams: NavParams,
      public navCtrl: NavController,
      public user: UserData
  ) {
    this.mySelectedIndex = navParams.data.tabIndex || 0;
  }
  ionViewWillEnter() {
    //this.user.checkLoggedIn(this.navCtrl,'SchedulePage');
  }
}



// WEBPACK FOOTER //
// ./src/pages/account/tabs/tabs.ts